import { render, staticRenderFns } from "./petContainer.vue?vue&type=template&id=43a28d19&"
var script = {}
import style0 from "./petContainer.vue?vue&type=style&index=0&id=43a28d19&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports